import React, {Component} from 'react';
import FiltersForm from "./components/FiltersForm";
import QueryGroup from "./components/QueryGroup";

class MongoDbProfiler extends Component {
    static propTypes = {};
    static defaultProps = {};
    state = {
        isEnabled: false,
        queryGroups: [
            {
                id: "fsdfsfsdfs",
                url: "/foo/bar",
                userName: "user@example.org",
                queries: [
                    {
                        body: "db.Tests.find({foo: \"bar\"})",
                        oollection: "Tests",
                        duration: 300,
                        recordsReturned: 2,
                        timestamp: new Date()
                    }
                ]
            }
        ]
    };

    render() {
        return (
            <div>
                <div className="page-header">
                    <div className="row">
                        <div className="col-md-4 text-xs-center text-md-left text-nowrap">
                            <h1>
                                <span className="text-muted font-weight-light">
                                    <i className="page-header-icon ion-settings"/> Для разработчиков /
                                </span> MongoDB профайлер
                            </h1>
                        </div>
                        <div className="col-xs-12 width-md-auto width-lg-auto width-xl-auto pull-md-right">
                            <button type="button"
                                    className={`btn btn-primary ${this.state.isEnabled ? '' : 'btn-outline'} btn-block`}
                                    onClick={() => this.toggleMongoDbProfiler()}>
                                <i className={`fa ${this.state.isEnabled ? 'fa-check-square-o' : 'fa-square-o'}`}/>&nbsp;
                                {this.state.isEnabled ? 'Выключить' : 'Включить'}
                            </button>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-xl-4 pull-xl-right">
                        <FiltersForm onChange={filters => this.applyFilters(filters)}/>
                    </div>
                    <div className="col-xl-8">
                        {this.state.queryGroups.map(qg => <QueryGroup key={qg.id} data={qg}/>)}
                    </div>
                </div>
            </div>
        );
    }

    applyFilters(filters) {
        console.log(filters);
    }

    toggleMongoDbProfiler() {
        if (this.state.isEnabled) {

        } else {

        }

        this.setState({
            isEnabled: !this.state.isEnabled
        })
    }
}

export default MongoDbProfiler;


// WEBPACK FOOTER //
// ./src/pages/Developers/MongoDbProfiler/MongoDbProfiler.js